import React, { useCallback } from "react";
import { withTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import 'bootstrap-icons/font/bootstrap-icons.css';

const BackAnchor = ({ t, i18n, backPath, backPathQuestion, onBackClick }) => {
  const navigate = useNavigate();
  const handleGoBack = useCallback(
    (e) => {
      e.preventDefault();
      if (onBackClick) {
        onBackClick();
      }
      backPath
        ? backPathQuestion
          ? navigate(
            `/${i18n.language}${t(backPath)}?question=${backPathQuestion}`
          )
          : navigate(`/${i18n.language}${t(backPath)}?disableGA=true`)
        : navigate(-1);
    },
    [navigate, onBackClick, backPath, i18n.language, t, backPathQuestion]
  );

  return (
    <div className="row">
      <div className="col-xs-12">
        <div style={{ margin: "5px 0 5px 0" }}>
          <div className="backTick">
            <i className="bi bi-arrow-left" style={{ cursor: 'pointer' }} onClick={handleGoBack}
              href={`/${i18n.language}${t(backPath)}`}></i>                     <a
                onClick={handleGoBack}
                href={`/${i18n.language}${t(backPath)}`}
                className="ns-back-link"
              >
              {t("shared.back")}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withTranslation("common")(BackAnchor);
